import { Block, Button, Message } from "react-bulma-components";
import React from "react";

export default function ProjectSection({ actions, alwaysShowChildren, children, itemCount, noItemsText, title }) {
    let content;
    if (alwaysShowChildren || itemCount > 0) {
        content = children;
    }

    return (
        <Block>
            <div className="is-flex">
                <h2 className="title is-4 is-flex-grow-1">{ title }</h2>

                <Button.Group alignItems="flex-start">
                    { actions }
                </Button.Group>
            </div>

            {
                itemCount === 0
                    ? <Message color="warning"><Message.Body>{ noItemsText }</Message.Body></Message>
                    : null
            }

            { content }
        </Block>
    )
}
